import React, { useState, memo } from 'react';
import { BookOpenIcon, PlusIcon, SettingsIcon, UserIcon, ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
export const Navigation = ({
  classes,
  activeClass,
  activeNote,
  onSelectClass,
  onSelectNote,
  onAddClass,
  onAddNote
}) => {
  const [expandedClasses, setExpandedClasses] = useState({});
  const [isAddingClass, setIsAddingClass] = useState(false);
  const [newClassName, setNewClassName] = useState('');
  const [addingNoteToClass, setAddingNoteToClass] = useState(null);
  const [newNoteName, setNewNoteName] = useState('');
  const toggleExpand = classId => {
    setExpandedClasses(prev => ({
      ...prev,
      [classId]: !prev[classId]
    }));
  };
  const handleAddClass = () => {
    if (newClassName.trim()) {
      onAddClass(newClassName);
      setNewClassName('');
      setIsAddingClass(false);
    }
  };
  const handleAddNote = classId => {
    if (newNoteName.trim()) {
      onAddNote(classId, newNoteName);
      setNewNoteName('');
      setAddingNoteToClass(null);
    }
  };
  return <nav className="w-64 bg-white border-r border-gray-200 flex flex-col h-full" data-id="element-11">
      <div className="p-4 border-b border-gray-200" data-id="element-12">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aQfNaBGgwsuA51QPFAW3Fm/Screenshot_from_2025-06-16_18-38-26.png" alt="Notiv" className="h-8" data-id="element-13" />
        <p className="text-sm text-gray-500 mt-1" data-id="element-14">memorize efficiently</p>
      </div>
      <div className="flex-1 overflow-y-auto p-4" data-id="element-15">
        <div className="flex items-center justify-between mb-4" data-id="element-16">
          <h2 className="font-medium text-gray-700" data-id="element-17">Classes</h2>
          <button onClick={() => setIsAddingClass(true)} className="p-1 rounded-full hover:bg-gray-100" title="Add Class" data-id="element-18">
            <PlusIcon size={18} className="text-blue-600" data-id="element-19" />
          </button>
        </div>
        {isAddingClass && <div className="mb-3 flex items-center" data-id="element-20">
            <input type="text" value={newClassName} onChange={e => setNewClassName(e.target.value)} placeholder="Class name" className="flex-1 p-1 text-sm border border-gray-300 rounded mr-1" onKeyDown={e => e.key === 'Enter' && handleAddClass()} data-id="element-21" />
            <button onClick={handleAddClass} className="p-1 bg-blue-600 text-white rounded" data-id="element-22">
              Add
            </button>
          </div>}
        <ul className="space-y-2" data-id="element-23">
          {classes.map(cls => <li key={cls.id} data-id="element-24">
              <div className={`flex items-center justify-between p-2 rounded cursor-pointer ${activeClass === cls.id ? 'bg-blue-100' : 'hover:bg-gray-100'}`} onClick={() => {
            onSelectClass(cls.id);
            onSelectNote(null);
            toggleExpand(cls.id);
          }} data-id="element-25">
                <div className="flex items-center" data-id="element-26">
                  <BookOpenIcon size={18} className="mr-2 text-gray-600" data-id="element-27" />
                  <span className="text-gray-800" data-id="element-28">{cls.name}</span>
                </div>
                <div className="flex items-center" data-id="element-29">
                  <span className="text-xs text-gray-500 mr-2" data-id="element-30">
                    {cls.score}%
                  </span>
                  <button onClick={e => {
                e.stopPropagation();
                toggleExpand(cls.id);
              }} data-id="element-31">
                    {expandedClasses[cls.id] ? <ChevronDownIcon size={18} className="text-gray-500" data-id="element-32" /> : <ChevronRightIcon size={18} className="text-gray-500" data-id="element-33" />}
                  </button>
                </div>
              </div>
              {expandedClasses[cls.id] && <div className="ml-6 mt-1" data-id="element-34">
                  <ul className="space-y-1" data-id="element-35">
                    {cls.notes.map(note => <li key={note.id} className={`p-1 pl-2 text-sm rounded cursor-pointer ${activeNote === note.id ? 'bg-blue-100' : 'hover:bg-gray-100'}`} onClick={() => {
                onSelectClass(cls.id);
                onSelectNote(note.id);
              }} data-id="element-36">
                        <div className="flex items-center justify-between" data-id="element-37">
                          <span className="text-gray-700" data-id="element-38">{note.title}</span>
                          <span className="text-xs text-gray-500" data-id="element-39">
                            {note.score}%
                          </span>
                        </div>
                      </li>)}
                  </ul>
                  {addingNoteToClass === cls.id ? <div className="mt-2 flex items-center" data-id="element-40">
                      <input type="text" value={newNoteName} onChange={e => setNewNoteName(e.target.value)} placeholder="Note title" className="flex-1 p-1 text-xs border border-gray-300 rounded mr-1" onKeyDown={e => e.key === 'Enter' && handleAddNote(cls.id)} data-id="element-41" />
                      <button onClick={() => handleAddNote(cls.id)} className="p-1 text-xs bg-blue-600 text-white rounded" data-id="element-42">
                        Add
                      </button>
                    </div> : <button onClick={() => setAddingNoteToClass(cls.id)} className="mt-2 flex items-center text-xs text-blue-600 hover:text-blue-800" data-id="element-43">
                      <PlusIcon size={14} className="mr-1" data-id="element-44" />
                      Add Note
                    </button>}
                </div>}
            </li>)}
        </ul>
      </div>
      <div className="border-t border-gray-200 p-4" data-id="element-45">
        <div className="flex items-center justify-center space-x-6" data-id="element-46">
          <button className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-47">
            <SettingsIcon size={20} className="text-gray-600" data-id="element-48" />
          </button>
          <button className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-49">
            <UserIcon size={20} className="text-gray-600" data-id="element-50" />
          </button>
        </div>
      </div>
    </nav>;
};